import type { FC } from 'react'

import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { type MyObjectStatus, myObjectStatuses } from '../../model/types'

import s from './styles.module.scss'

interface Props {
  activeStatus: MyObjectStatus
  onChange: (status: MyObjectStatus) => void
}

export const MyObjectsStatusTabs: FC<Props> = ({ activeStatus, onChange }) => {
  const { t } = useTranslation()

  return (
    <div
      className={s.tabs}
      role="tablist"
      aria-label={t('kyrgyzstan_block.my_objects.title')}
    >
      {myObjectStatuses.map((status) => (
        <button
          key={status}
          type="button"
          role="tab"
          aria-selected={activeStatus === status}
          className={clsx('medium-15', s.tab, {
            [s.active]: activeStatus === status,
          })}
          onClick={() => onChange(status)}
        >
          {t(`kyrgyzstan_block.my_objects.tabs.${status}`)}
        </button>
      ))}
    </div>
  )
}
